import { useCallback, useState } from 'react';
import type { Evenement } from '@qc/db';
import { supabase } from '../supabase.js';

export interface Prijsmodelvelden {
  dagtariefKraamsetCent: number;
  /** In tienden van een cent: € 0,066 wordt 66. */
  doorbelastPerBonTiendeCent: number;
  doorbelastOverOmzetBp: number;
  inkoopPerBonTiendeCent: number;
  inkoopOverOmzetBp: number;
  eigenKostenCent: number;
  bufferBp: number;
  bufferDagen: number;
}

export function velden(evenement: Evenement): Prijsmodelvelden {
  return {
    dagtariefKraamsetCent: evenement.dagtarief_kraamset_cent,
    doorbelastPerBonTiendeCent: evenement.transactiekosten_per_bon_tiende_cent,
    doorbelastOverOmzetBp: evenement.transactiekosten_over_omzet_bp,
    inkoopPerBonTiendeCent: evenement.inkoop_per_bon_tiende_cent,
    inkoopOverOmzetBp: evenement.inkoop_over_omzet_bp,
    eigenKostenCent: evenement.eigen_kosten_cent,
    bufferBp: evenement.buffer_bp,
    bufferDagen: evenement.buffer_dagen,
  };
}

export interface PrijsmodelOpslag {
  bewaren: (evenementId: string, waarden: Prijsmodelvelden) => Promise<boolean>;
  bezig: boolean;
  fout: string | null;
}

export function usePrijsmodel(): PrijsmodelOpslag {
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState<string | null>(null);

  const bewaren = useCallback(async (evenementId: string, waarden: Prijsmodelvelden) => {
    setBezig(true);
    const { error } = await supabase
      .from('evenementen')
      .update({
        dagtarief_kraamset_cent: waarden.dagtariefKraamsetCent,
        transactiekosten_per_bon_tiende_cent: waarden.doorbelastPerBonTiendeCent,
        transactiekosten_over_omzet_bp: waarden.doorbelastOverOmzetBp,
        inkoop_per_bon_tiende_cent: waarden.inkoopPerBonTiendeCent,
        inkoop_over_omzet_bp: waarden.inkoopOverOmzetBp,
        eigen_kosten_cent: waarden.eigenKostenCent,
        buffer_bp: waarden.bufferBp,
        buffer_dagen: waarden.bufferDagen,
      })
      .eq('id', evenementId);
    setBezig(false);

    if (error) {
      setFout('Het prijsmodel kon niet worden opgeslagen.');
      return false;
    }
    setFout(null);
    return true;
  }, []);

  return { bewaren, bezig, fout };
}
